import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ApplicationAutomationSettingsLoader from "./application-automation-settings-loader";
import ListDetails from "../../../../marketing/components/lists/list-details";
import MaterialInput from "@Shared/components/inputs/material-input";
import TimeInput from "../../components/argument-types/time";
import { LOAD_MARKETING_EMAILS, CREATE_NEW_LIST, UPDATE_LIST } from "../../../../marketing/store/marketing/marketing-actions";
import { GET_MARKETING_EMAILS } from "../../../../marketing/store/marketing/marketing-getters";
import { LOAD_DEFAULT_LIST } from "../../store/automation-actions";
import { UPDATE_ACCOUNT_PREFERENCES } from "@Broker/@Modules/main/store/account/account-actions";
import CampaignFromSection from "../../../../marketing/components/campaigns/campaign-from-section";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "../../../../../../../shared/utils/amplitude";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationLevelSettings",
  title() {
    return this.$t("sidebar.sections.applications");
  },
  components: {
    ListDetails,
    CampaignFromSection,
    ApplicationAutomationSettingsLoader,
    MaterialInput,
    SimpleButton,
    TimeInput
  },
  mixins: [validationMixin],
  validations: {
    formData: {
      defaultList: {
        address: {
          line1: {
            required
          },
          province: {
            required
          },
          company: {
            required
          },
          city: {
            required
          },
          "postal-code": {
            required
          }
        }
      },
      defaultEmailName: {
        required
      },
      defaultMarketingEmail: {
        email: {
          email
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      listVisibility: {
        name: false,
        description: false,
        address: true,
        company: true
      },
      submitting: {
        loading: false,
        status: true
      },
      formData: {
        defaultList: {},
        defaultListId: "",
        defaultEmailId: "",
        defaultMarketingEmail: {},
        defaultEmailName: "",
        applicationAutomationTime: ""
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("AccountStore", ["accountPreferences.defaultListId", "accountPreferences.defaultEmailName", "accountPreferences.defaultEmailId", "accountPreferences.applicationAutomationTime"])), mapFields("AutomationStore", ["defaultMarketingEmail", "defaultList"])), mapState("MarketingStore", ["lists", "marketingEmails"])), mapGetters("MarketingStore", [GET_MARKETING_EMAILS])), {}, {
    applicationAutomationRootRoute() {
      return {
        name: "application-automations"
      };
    },
    fromData() {
      return {
        emailName: this.formData.defaultEmailName,
        email: this.formData.defaultMarketingEmail
      };
    },
    localApplicationAutomationTime() {
      return this.formData.applicationAutomationTime;
    },
    localDefaultList() {
      return isEmpty(this.formData.defaultList) ? this.defaultList : this.formData.defaultList;
    },
    isValid() {
      return !this.$v.$invalid && this.formData.defaultMarketingEmail.verified;
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Automations - application level settings visited");
  },
  mounted() {
    this.loading = true;
    this.formData.defaultEmailName = this.defaultEmailName;
    this.formData.defaultEmailId = this.defaultEmailId;
    this.formData.applicationAutomationTime = this.applicationAutomationTime;
    if (this.defaultListId) {
      this.formData.defaultListId = this.defaultListId;
      this.LOAD_DEFAULT_LIST().then(() => this.formData.defaultList = this.defaultList);
    }
    this.LOAD_MARKETING_EMAILS().then(() => {
      const currentDefaultEmail = this.marketingEmails.byId[this.defaultEmailId];
      if (!isEmpty(this.marketingEmails.byId) && currentDefaultEmail) {
        this.formData.defaultMarketingEmail = currentDefaultEmail;
      }
      this.loading = false;
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_MARKETING_EMAILS, CREATE_NEW_LIST, UPDATE_LIST])), mapActions("AccountStore", [UPDATE_ACCOUNT_PREFERENCES])), mapActions("AutomationStore", [LOAD_DEFAULT_LIST])), {}, {
    async handleSubmit() {
      try {
        this.submitting.loading = true;
        const {
          defaultList,
          defaultEmailId,
          defaultEmailName,
          defaultMarketingEmail,
          applicationAutomationTime
        } = this.formData;
        this.defaultList = defaultList;
        this.defaultEmailId = defaultEmailId;
        this.defaultEmailName = defaultEmailName;
        this.defaultMarketingEmail = defaultMarketingEmail;
        this.applicationAutomationTime = applicationAutomationTime;
        if (!this.defaultListId) {
          const {
            listId
          } = await this.CREATE_NEW_LIST(_objectSpread(_objectSpread({}, this.defaultList), {}, {
            name: "Default Marketing List",
            description: "Default Marketing List Description",
            system: true
          }));
          this.defaultListId = listId;
        } else {
          await this.UPDATE_LIST({
            listId: this.defaultListId,
            data: this.defaultList
          });
        }
        await this.UPDATE_ACCOUNT_PREFERENCES();
        this.$router.replace(this.applicationAutomationRootRoute);
        showToast("success", "automationSettingsUpdated");
      } catch (e) {
        this.submitting.status = false;
      } finally {
        this.submitting.loading = false;
      }
    },
    handleChangeList(list) {
      this.formData.defaultList = list;
    },
    handleChangeFromData({
      email,
      emailName
    }) {
      this.formData.defaultEmailId = email.emailId;
      this.formData.defaultMarketingEmail = email;
      this.formData.defaultEmailName = emailName;
    },
    handleChangeAutomationTime(time) {
      this.formData.applicationAutomationTime = time;
    }
  })
});